import { render, staticRenderFns } from "./OsobaPotvrda.vue?vue&type=template&id=96ba7f8a&scoped=true&"
import script from "./OsobaPotvrda.vue?vue&type=script&lang=js&"
export * from "./OsobaPotvrda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba7f8a",
  null
  
)

export default component.exports